import React from 'react'
import { useSelector } from 'react-redux'

export default function Redactor(props) {
    const accountId = useSelector((state) => state.accountMaster?.id)

    if (!accountId) return null
    let Editor = undefined
    Editor = require('./RedactorNew').default
    return <Editor {...props} />
}
